import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'igo-panel',
  template: require('./panel.component.html'),
  styles: [require('./panel.component.styl')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelComponent {

  @Input()
  get title() { return this._title; }
  set title(value: string) {
    this._title = value;
  }
  private _title: string;

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/panel/panel.component.ts